import React from "react";
import "./Skills.css";

// import ReactTooltip from "react-tooltip";

import { AiFillEye, AiFillGithub } from "react-icons/ai";

import { motion } from "framer-motion";
import { AppWrap, MotionWrap } from "../../wrapper";
import { images } from "../../constants";
import { useState } from "react";

const mySkills = [
  {
    name: "Shopify Themes",
    imgUrl: images.shopifyImage,
  },
  {
    name: "Shopify Liquid",
    imgUrl: images.liquidImage,
  },
  {
    imgUrl: images.javasCriptOne,
    name: "JavaScript",
  },
  {
    name: "Figma",
    imgUrl: images.figmaIconSkill,
  },
  
];

const myExperiences = [
  {
    year: "Since 2022",
    name: "SHOPIFY STORE DESIGNER AND DEVELOPER",
    desc: "I have helped businesses develop and setup their Shopify store, including choosing themes, configuring settings, design, develop the store and setting up payment gateways",
    tags: [
      "Shopify Themes",
      "Shopify Liquid",
      "JavaScript",
      "Figma",
      
    ],
  },
  {
    year: "Since 2021",
    name: "SHOPIFY THEME DEVELOPER",
    desc: "I have helped businesses create custom Shopify themes tailored to the business's brand identity and requirements",
    tags: [
      "Shopify Liquid",
      "JavaScript",
    ],
  },
  {
    year: "Since 2020",
    name: "SHOPIFY THEME CUSTOMIZATION",
    desc: "I have helped businesses Modify existing Shopify themes to match specific design preferences or add custom functionality",
    tags: ["Shopify Themes"],
  },
  {
    year: "Since 2019",
    name: "SHOPIFY STORE DESIGNER",
    desc: "I have helped businesses craft the look and appearance of their shopify stores",
    tags: ["Figma"],
  },
];

const Skills = () => {
  const [experience, setExperience] = useState(myExperiences);
  const [skills, setSkills] = useState(mySkills);

  return (
    <>
      <h2 className="head-text">Skills & Experience</h2>
      <div className="app__skills-container">
        <motion.div className="app__skills-list">
          {skills.map((skill, index) => (
            <motion.div
              whileInView={{ opacity: [0, 1] }}
              transition={{ duration: 0.5 }}
              className="app__skills-item app__flex"
              key={index}
            >
              <div
                className="app__flex"
                style={{ backgroundColor: skill.bgColor }}
              >
                <img src={skill.imgUrl} alt={skill.name} />
              </div>

              <p className="p-text">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div className="app__skills-exp">
          {experience.map((exper, index) => (
            <motion.div className="app__skils-exp-item" key={index}>
              <div className="app__skills-exp-year">
                <p className="bold-text">{exper.year}</p>
              </div>

              <h4 className="bold-text">{exper.name}</h4>
              <p className="p-text exp-desc">{exper.desc}</p>

              <div className="technologies-used">
                <div className="">Technologies:</div>
                <div className="technology">
                  {exper.tags.map((tag, index) => (
                    <div className="tech  p-text" key={index}>
                      {tag}
                    </div>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Skills, "app__skills"),
  "skills",
  "app__whitebg"
);
